import BookHistory from "./panels/BookHistory";
import BookInformation from "./panels/BookInformation";
import AddDamage from "./panels/AddDamage";

export default function RightPanel({
    view,
    book,
    loading,
    damageInitialData,
    onViewChange,
    onClose,
}) {
    const showLoader = loading && view === "BOOK_SETTINGS";

    return (
        <div className="flex-1 min-w-0 h-full overflow-y-auto bg-white">
            <div className="w-full max-w-5xl mx-auto px-6 md:px-10 py-6">

                {showLoader && (
                    <div className="w-full min-h-[300px] flex items-center justify-center">
                        <p className="text-sm text-gray-400">
                            Loading book information…
                        </p>
                    </div>
                )}

                {!showLoader && view === "BOOK_HISTORY" && book && (
                    <BookHistory book={book} onClose={onClose} onViewChange={onViewChange} />
                )}

                {!showLoader && view === "BOOK_SETTINGS" && book && (
                    <BookInformation book={book} onClose={onClose} />
                )}

                {!showLoader && view === "BOOK_DAMAGE" && book && (
                    <AddDamage
                        book={book}
                        initialMemberId={damageInitialData?.memberId}
                        initialOrderId={damageInitialData?.orderId}
                        onClose={onClose}
                    />
                )}


                {!book && view === "NONE" && <NoSelection />}
            </div>
        </div>
    );
}

function NoSelection() {
    return (
        <div className="w-full min-h-[300px] flex items-center justify-center">
            <h2 className="text-3xl text-gray-300 font-medium">
                No Book Selected
            </h2>
        </div>
    );
}
